<script lang="ts">
  import { navigate } from 'svelte-routing';
</script>

<div class="min-h-screen flex flex-col items-center justify-center bg-gray-50">
  <div class="text-center">
    <h1 class="text-6xl font-bold text-gray-300 mb-4">404</h1>
    <p class="text-xl text-gray-600 mb-8">ページが見つかりません</p>
    <button
      on:click={() => navigate('/')}
      class="btn btn-primary"
    >
      トップページへ
    </button>
  </div>
</div>
